
import { IconLeaf } from '@backmarket/design-system'

import translations from './EcoBlockAnchor.translations'

export default {
  components: {
    IconLeaf,
  },

  computed: {
    translations: () => translations,
  },

  methods: {
    handleClick(e) {
      // Let's prevent the default anchor behavior (keeping the anchor it for a11y)
      e.preventDefault()

      // Using getElementById instead of ref as the target is in another component
      document.getElementById('ecoBlocks').scrollIntoView({
        behavior: 'smooth',
        // Centering the block in the page to avoid sticky elements hidden the first lines.
        block: 'center',
      })
    },
  },
}
